import FlatTable, { flatValue } from "../../../../../../Components/common/FlatTable/FlatTable";

import "./flatStyles.scss";

// See CrimesFlat: the cap keeps html2canvas from running out of memory at
// scale 2. The JSON and CSV exports are uncapped.
const MAX_ISSUES = 50;

const columns = [
  {
    label: "Description",
    render: (row) => flatValue(row?.metadata?.description),
    className: "android-static-code-issues-flat__description",
  },
  { label: "CWE", render: (row) => flatValue(row?.metadata?.cwe) },
  { label: "MASVS", render: (row) => flatValue(row?.metadata?.masvs) },
  // The key carries a hyphen, so it can only be read with bracket access
  { label: "Owasp Mobile", render: (row) => flatValue(row?.metadata?.["owasp-mobile"]) },
  { label: "Severity", render: (row) => flatValue(row?.metadata?.severity) },
];

// Stateless counterpart of StaticCodeIssues.js. Note the array guard: the slice
// initialises staticCodeIssues to {} and resets it to {} on failure.
const StaticCodeIssuesFlat = ({ data }) => (
  <div className="android-static-code-issues-flat">
    <FlatTable
      columns={columns}
      data={Array.isArray(data) ? data : []}
      maxRows={MAX_ISSUES}
      moreLabel="issues"
      emptyMessage="No static code issues found"
    />
  </div>
);

export default StaticCodeIssuesFlat;
